import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

import { DispatchAssignmentRead } from 'src/common/external/bambi-api/bambiApi';

import { AssignmentHeaderBadges } from './AssignmentHeaderBadges';

interface AssignmentHeaderPopoverProps {
  assignment: DispatchAssignmentRead;
}
export function AssignmentHeaderPopover({
  assignment,
}: AssignmentHeaderPopoverProps) {
  return (
    <SimpleTooltip
      trigger={<InformationCircleIcon className="h-4 w-4" />}
      content={<AssignmentHeaderBadges assignment={assignment} />}
      testId="assignment-header-popover-trigger"
    />
  );
}
